/* eslint-disable import/extensions, import/no-unresolved */
import React from 'react';
import { FONT_SIZE } from '@latitude/core/utils/constants';
import { StaticImage } from 'gatsby-plugin-image';

import {
  StyledHeroBranded,
  ImageBox,
  LeaderDetailsWrapper,
  DetailsContainer,
  StyledText,
  LeadershipPageLayout
} from '../../../components/Leadership';

export default props => {
  const title = 'Karl Hoffman';
  const content =
    'Executive General Manager, Corporate Strategy & Transformation';

  return (
    <LeadershipPageLayout title={title} {...props}>
      <StyledHeroBranded
        title={title}
        text={content}
        breadcrumbs={[
          {
            name: 'About us',
            href: '/about-us/'
          },
          {
            name: 'Our company',
            href: '/about-us/our-company/'
          },
          {
            name: 'Karl Hoffman'
          }
        ]}
        imageContent={
          <ImageBox>
            <StaticImage
              alt={title}
              src="../images/karl-hoffman-1.webp"
              width={450}
              quality={100}
              placeholder="dominantColor"
            />
          </ImageBox>
        }
      />
      <LeaderDetailsWrapper>
        <DetailsContainer display="flex">
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Karl was appointed Executive General Manager, Corporate Strategy &
            Transformation, in May 2023. Before that, he led strategy and
            performance in Latitude’s Money division and was CFO and Head of
            Corporate Strategy at Symple Loans, which Latitude acquired in 2021.
            <br />
            <br />
            Karl has over 20 years of financial services experience and began
            his career in asset management with Merrill Lynch and Partners
            Capital Group in London. Karl moved to Australia in 2008 and worked
            at Bain & Company and then joined ANZ's Group Strategy team leading
            growth and optimisation initiatives across ANZ's Retail, Business
            and Institutional banking divisions.
          </StyledText>
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Karl holds a bachelors degree in Business Administration from Simon
            Fraser University in Canada, an MBA from Melbourne Business School
            and qualified as a CFA Charterholder in 2007.
          </StyledText>
        </DetailsContainer>
      </LeaderDetailsWrapper>
    </LeadershipPageLayout>
  );
};
